<article class="row" [ngClass]="rowSpacing">
  <div class="col col-12">
    <div
      sc-placeholder
      name="single-column"
      [ngClass]="contentOptions"
      [rendering]="rendering"
    ></div>
  </div>
</article>
